module.exports = __webpack_public_path__ + "static/media/carruselManualBig.0a72c931.png";